var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 26c0 1.106-.894 2-2 2s-2-.894-2-2 .894-2 2-2 2 .894 2 2zm8-23v26c0 1.656-1.344 3-3 3H3c-1.656 0-3-1.344-3-3V3c0-1.656 1.344-3 3-3h14c1.656 0 3 1.344 3 3zm-3 25.625V3.375A.376.376 0 0 0 16.625 3H3.375A.376.376 0 0 0 3 3.375v25.25c0 .206.169.375.375.375h13.25a.376.376 0 0 0 .375-.375z"}));
}

Mobile.defaultProps = {"viewBox":"0 0 20 32"};

module.exports = Mobile;

Mobile.default = Mobile;
